/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Start_C_TInputs */

const en_wc_start_c_t = /** @type {(inputs: Wc_Start_C_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save and check your work`)
};

/**
* | output |
* | --- |
* | "Save and check your work" |
*
* @param {Wc_Start_C_TInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_start_c_t = /** @type {((inputs?: Wc_Start_C_TInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Start_C_TInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_start_c_t(inputs)
});
export { wc_start_c_t as "wc.start.c_t" }